import React from "react";
import { some } from "lodash";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { connect, type ConnectedProps } from "react-redux";
import { push } from "store/actions/router";
import { Col, Row } from "react-bootstrap";
import { isIndividualAccountOverview } from "store/selectors/user";
import type { RootState } from "types/state";
import BalanceKpi from "./BalanceKpi";

import PerformanceTable from "./PerformanceTable";
import PaychexRolloverStatus from "./PaychexRolloverStatus";
import PerksEnrollmentCard from "./PerksEnrollmentCard";
import IndividualOverview from "./IndividualOverview";
import PaychexSecondRolloverCard from "./PaychexSecondRolloverCard";

import "./IndividualDashboard.scss";

const mapStateToProps = (state: RootState) => {
  const accounts = state.accounts.iraAccounts;

  const shouldShowBalanceInformation = some(
    accounts,
    (account) => account.balances && account.balances.totalAccountBalance! > 0
  );

  return {
    isAccountOverview: isIndividualAccountOverview(state),
    shouldShowBalanceInformation,
  };
};
const mapDispatchToProps = {
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  hasBankAccount?: boolean;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class PaychexDashboard extends React.PureComponent<Props> {
  multiAccountView = () => {
    return (
      <div>
        <PaychexRolloverStatus />
        <PaychexSecondRolloverCard />
        <PerksEnrollmentCard />
        <IndividualOverview />
      </div>
    );
  };

  singleAccountView = () => {
    return (
      <div>
        <PaychexRolloverStatus />
        <PaychexSecondRolloverCard />
        <PerksEnrollmentCard />
        {this.props.shouldShowBalanceInformation && (
          <Row>
            <Col md={12}>
              <BalanceKpi hasBankAccount={this.props.hasBankAccount} />
            </Col>

            <Col md={12}>
              <PerformanceTable />
            </Col>
          </Row>
        )}
      </div>
    );
  };

  render() {
    let content;

    if (this.props.isAccountOverview) {
      content = this.multiAccountView();
    } else {
      content = this.singleAccountView();
    }

    return <div className="dashboard-content">{content} </div>;
  }
}

export default connector(
  withApollo<OwnProps & PropsFromRedux>(PaychexDashboard)
);
